<template>
  <div>
    <div class="page_title">
      <div class="page_title-text">
        <span is="i18n">
          <span lang="ru">Контакты</span>
          <span lang="en">Contacts</span>
          <span lang="kk">Байланыстар</span>
        </span>
      </div>
    </div>
    <!-- <div class="contact_feedback">
      <form class="contact_feedback-form" action="POST">
        <div class="row">
          <input
            id="email"
            class="contact_feedback-form-email"
            type="email"
            name="email"
            placeholder="Ваш e-mail..."
            required
          />
          <button class="btn contact_feedback-form-button" type="submit">
            <span>Отправить</span>
          </button>
        </div>
      </form>
    </div> -->
    <div class="row contact_info">
      <div class="col-lg-6 col-12">
        <yandex-map :settings="settings" :coords="coords" :zoom="18">
          <ymap-marker :coords="coords" marker-id="123" hint-content="Зверева 47" />
        </yandex-map>
      </div>
      <div class="col-lg-6 col-12">
        <div class="contact_info-text">
          <div class="row contact_info-header">
            <div class="contact_info-header-phone">
              <i class="icon telephone"></i>
              <a href="tel:+77272588180">+7 (727) 258 81 80</a>
            </div>
            <div class="contact_info-header-mail">
              <i class="icon mail"></i>
              <a href="mailto:team@kagis.kz">team@kagis.kz</a>
            </div>
          </div>
          <div class="contact_info-subtext">
            <span is="i18n">
              <span lang="ru">
                ТОО «Казахстанское агентство ГИС и ДЗ» <br />
                Республика Казахстан, г. Алматы, ул. М. Зверева 47 <br />
                РНН 600 900 613 614 <br />
                ИИК KZ20826A1KZTD2003788 <br />
                БИК ALMNKZKA <br />
                БИН 081040012416 <br />
                АО АТФ Банк г. Алматы <br />
              </span>
              <span lang="en">
                LLP "Kazakhstan Agency of GIS and RS" <br />
                47 M. Zvereva str., Almaty, Republic of Kazakhstan <br />
                RNN 600 900 613 614 <br />
                IIC KZ20826A1KZTD2003788 <br />
                BIC ALMNKZKA <br />
                BIN 081040012416 <br />
                JSC ATF Bank Almaty
              </span>
              <span lang="kk">
                "Қазақстан ГИС және ДЗ агенттігі" ЖШС <br />
                Қазақстан Республикасы, Алматы қ., М. Зверева к-сі 47 <br />
                СТН 600 900 613 614 <br />
                ИИК KZ20826A1KZTD2003788 <br />
                БИК ALMNKZKA <br />
                БСН 081040012416 <br />
                Алматы қ. "АТФ Банк" АҚ
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Mapbox from 'mapbox-gl-vue';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';

export default {
  name: 'Contacts',
  components: { yandexMap, ymapMarker },
  data: () => ({
    settings: {
      apiKey: 'b403740a-ccc2-4cd5-b7b2-3c40847a8f43',
    },
    coords: [43.248859, 76.962434],
  }),
  methods: {
    // loaded(map) {
    //   map.addLayer({
    //     id: 'points',
    //     type: 'symbol',
    //     source: {
    //       type: 'geojson',
    //       data: {
    //         type: 'FeatureCollection',
    //         features: [
    //           {
    //             type: 'Feature',
    //             geometry: {
    //               type: 'Point',
    //               coordinates: [76.891665, 43.239298],
    //             },
    //             properties: {
    //               title: 'Kagis',
    //               icon: 'marker',
    //             },
    //           },
    //         ],
    //       },
    //     },
    //     layout: {
    //       'icon-image': '{icon}-15',
    //       'text-field': '{title}',
    //       'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
    //       'text-offset': [0, 0.6],
    //       'text-anchor': 'top',
    //     },
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.contact_feedback {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  margin: 80px auto 60px;
  justify-content: center;
  align-items: center;
}

.contact_feedback-form {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  .contact_feedback-form-email {
    width: 334px;
    height: 50px;
    border: 1px solid #d7d7d7;
    margin-right: 10px;
    padding: 0;
    outline: none;
    padding: 14px 0 14px 21px;
    font-size: 18px;
    line-height: 21px;
    color: #555555;
    .contact_feedback-form-button {
      width: 144px;
      background: #00aaff;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      color: #ffffff;
      margin-left: 10px;
    }
  }

  .contact_feedback-form-button:hover {
    background: #029deb;
  }
}

.contact_info {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
}

.contact_info-text {
  margin-left: 50px;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
}

.contact_info-header {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  font-size: 18px;
  line-height: 21px;
  color: #555555;
  margin: 16px 0;
  width: 100%;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
}

.contact_info-header-phone {
  display: inline-flex;
  margin-right: 16px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.contact_info-header-phone > a {
  color: #555555;
}

.contact_info-header-mail {
  display: inline-flex;
  margin-left: 16px;
  justify-content: center;
  align-items: center;
}

.contact_info-header-mail > a {
  color: #555555;
}

.contact_info-subtext {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 28px;
  color: #555555;
  margin-top: 16px;
}

.ymap-container {
  width: 100%;
  height: 267px;
  min-height: 250px;
  max-height: 320px;
  border-radius: 5px;
}

@media (max-width: 1140px) {
  .ymap-container,
  .contact_info-text {
    margin-left: 0 !important;
    margin-right: auto !important;
  }
  .ymap-container {
    width: 100%;
    height: 320px !important;
  }
  .contact_info-text {
    margin-top: 30px;
    max-width: 520px;
  }
  .contact_info-header-phone {
    margin-right: auto;
  }
  .contact_info-header-mail {
    margin-left: auto;
  }
}

@media (max-width: 576px) {
  .contact_feedback {
    margin-top: 30px;
  }
  .contact_feedback-form-email,
  .btn.contact_feedback-form-button {
    margin-right: auto !important;
    margin-left: auto !important;
    width: 100%;
    height: 50px;
  }
  .btn.contact_feedback-form-button {
    margin-top: 15px;
    height: 40px;
  }
}

@media (max-width: 400px) {
  .contact_info-header-mail {
    margin: 10px auto 0 0;
  }
}
</style>
